import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { A4_PORTRAIT } from 'src/views/Management/Reports/types'
import { ApplicationState } from 'src/store'
import { Empty } from 'src/components/Ant'

import { Footer, OptionsBar, TitleReport } from '..'
import { SectionHeader, TableDetail } from './components'
import { WrapPageContent, WrapPage } from '../../styles'
import { WrapTableDiv } from './styles'

const MaxRecordsFirstPage = 32
const MaxRecords = 43

function R9() {
  const {
    reports: {
      reportsResources: {
        R9Data: { data },
        R9Header: { data: header }
      }
    }
  } = useSelector((state: ApplicationState) => ({
    reports: state.reports
  }))

  const pages = useMemo(() => {
    if (header.length <= 3) {
      return [[<TitleReport title="web.report.9.title" />, <Empty />]]
    }

    const tempPages: JSX.Element[][] = []

    let index = 0
    let pageNumber = 0

    // Make pages //
    do {
      const sliceNumber = pageNumber === 0 ? MaxRecordsFirstPage : MaxRecords
      const page: JSX.Element[] = []
      page.push(<TitleReport title="web.report.9.title" />)

      if (pageNumber <= 0) {
        page.push(<SectionHeader />)
      }

      const maxRecordsPossible = data.slice(index, index + sliceNumber)
      page.push(
        <WrapTableDiv>
          <TableDetail dataSource={maxRecordsPossible} />
        </WrapTableDiv>
      )

      index += sliceNumber
      pageNumber += 1
      tempPages.push(page)
    } while (index < data.length)
    return tempPages
  }, [header, data])

  return (
    <>
      <OptionsBar />
      {pages.map((item, index) => (
        <WrapPage key={index} className="print" pageShape={A4_PORTRAIT}>
          <WrapPageContent>
            {item.map((t, i) => (
              <React.Fragment key={i}>{t}</React.Fragment>
            ))}
          </WrapPageContent>
          <Footer pagination={{ x: index + 1, y: pages.length }} />
        </WrapPage>
      ))}
    </>
  )
}

export default R9
